import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { propFunc, propShape, } from '../../../../../../helpers/custom-prop-types';
import RowActionDefault from './RowActionDefault';
import RowActionReview from './RowActionReview';
import RowActionSendOff from './RowActionSendOff';
class RowAction extends Component {
    constructor() {
        super(...arguments);
        this.onClickOrder = () => {
            const { item, onClickOrder } = this.props;
            onClickOrder(item);
        };
        this.onClickSendOff = () => {
            const { item, onClickSendOff } = this.props;
            onClickSendOff(item);
        };
        this.onClickReview = () => {
            const { item, onClickReview } = this.props;
            onClickReview(item);
        };
    }
    render() {
        const { item } = this.props;
        const { client_status: clientStatus, review } = item;
        if (clientStatus === 2) {
            return _jsx(RowActionSendOff, {});
        }
        if (clientStatus === 3) {
            return (_jsx(RowActionReview, { item: item, onClickReview: this.onClickReview, review: review }));
        }
        return (_jsx(RowActionDefault, { onClickOrder: this.onClickOrder, onClickSendOff: this.onClickSendOff }));
    }
}
RowAction.propTypes = {
    item: propShape().isRequired,
    onClickOrder: propFunc().isRequired,
    onClickReview: propFunc().isRequired,
    onClickSendOff: propFunc().isRequired,
};
export default RowAction;
